import APIVisualInterceptor from './APIVisualInterceptor';

export default APIVisualInterceptor;
